import React, { FC } from 'react';
import { Box } from '@wix/design-system';
import {
  GlobalDesignAction,
  GlobalDesignStyleGroup,
  StylesDerivedNativeActionNames,
} from './types';

type StyleLobbyListProps<T extends StylesDerivedNativeActionNames> = {
  items: GlobalDesignStyleGroup[];
  action: GlobalDesignAction<T>;
  onItemSelect: (item: GlobalDesignStyleGroup) => void;
};

const StyleLobbyList: FC<StyleLobbyListProps<any>> = ({
  items,
  action,
  onItemSelect,
}) => {
  return (
    <Box direction="vertical" gap="2" paddingTop="3">
      {items.map((item, i) => (
        <Box key={i}>
          {React.createElement(action.lobbyItem, {
            group: item,
            onSelect: () => onItemSelect(item),
          })}
        </Box>
      ))}
    </Box>
  );
};

export default StyleLobbyList;
